import { ACL_TYPE } from '@openx/types/aclType.ts';
import type { PermissionsCheck } from '@openx/utils/permission/useIsAllowed.ts';
import { isAllowedByCompiledAcl } from '@openx/utils/permission/validators.ts';
import { DV360_DEMAND_PARTNER_ID } from '@openx/utils/services/config.ts';

export function isDV360DemandPartner(demandPartnerId: string): boolean {
  return demandPartnerId === DV360_DEMAND_PARTNER_ID;
}

export function isDemandPartnerDropdownDisabled(
  demandPartnerId: string,
  isEdit: boolean,
  isDV360OnEditEntry: boolean
): boolean {
  return isDV360DemandPartner(demandPartnerId) && isEdit && isDV360OnEditEntry;
}

export function isToggleEnableDV360IPVisible(
  demandPartnerId: string,
  isAllowed: (check: PermissionsCheck) => boolean
): boolean {
  return (
    isDV360DemandPartner(demandPartnerId) &&
    isAllowed(isAllowedByCompiledAcl(ACL_TYPE.DEAL_ENABLE_DV360_INVENTORY_PACKAGE_WRITE))
  );
}
